import React, { Fragment, useRef } from "react";
import EventAbout from "./_sections_backup/about";
import EventDirection from "./_sections_backup/direction";
import EventHero from "./_sections_backup/hero";
import EventSeatBooking from "./_sections_backup/seat_booking";
import EventSpeaker from "./_sections_backup/speaker";
import EventTopics from "./_sections_backup/topics";
import EventWhyAttent from "./_sections_backup/why_attend";
import AttendUniversity from "./_sections_backup/attend_university";
import EventBlog from "./_sections_backup/blog";
import EventForm from "./_sections_backup/form";

export const EventsDetailsBackup = () => {
  const bookNowRef = useRef(null);
  const viewLocationRef = useRef(null);
  const goToBookNow = () => {
    bookNowRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const goToviewLocation = () => {
    viewLocationRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Fragment>
      <EventHero
        goToBookNow={goToBookNow}
        goToviewLocation={goToviewLocation}
      />

      <EventAbout
        goToBookNow={goToBookNow}
        goToviewLocation={goToviewLocation}
      />

      <EventWhyAttent
        goToBookNow={goToBookNow}
        goToviewLocation={goToviewLocation}
      />

      <EventTopics />

      <div ref={bookNowRef}>
        <EventSeatBooking />
      </div>
      <EventSpeaker />

      <AttendUniversity />

      <div ref={viewLocationRef}>
        <EventDirection />
      </div>

      <EventForm />

      <EventBlog />
    </Fragment>
  );
};

export default EventsDetailsBackup;
